import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fa fa-cog fa-spin fs-2 text-white"
}
const _hoisted_2 = {
  key: 1,
  class: "bi bi-download fs-2 text-white"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createBlock(_component_el_tooltip, {
    effect: "dark",
    content: "Descargar",
    placement: "top"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_button, {
        type: "success",
        disabled: $setup.loaderDown,
        onClick: $setup.DownloadFile
      }, {
        default: _withCtx(() => [
          ($setup.loaderDown)
            ? (_openBlock(), _createElementBlock("i", _hoisted_1))
            : (_openBlock(), _createElementBlock("i", _hoisted_2))
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }))
}